import createEnum from 'scripts/lib/create_enum';

const MessageContentType = createEnum('TEXT', 'IMAGE', 'FILE', 'LOCATION');

export default MessageContentType;
